export default {
      id: "delete-usage",
      viewBox: "0 0 14 14",
      url: __webpack_public_path__ + "img/icons.cd84ca0f.svg#delete",
      toString: function () {
        return this.url;
      }
    }